/**
 * Module dependencies.
 */

import Head from 'next/head';
import React, { ReactElement } from 'react';

/**
 * `Props` type.
 */

type Props = {
  faqs: Array<{
    answer: string,
    question: string
  }>
};

/**
 * `SchemaFaq` component.
 */

const SchemaFaq = (props: Props): ReactElement => {
  const { faqs } = props;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer
      },
      name: faq.question
    }))
  };

  return (
    <Head>
      <script
         // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          // eslint-disable-next-line id-match
          __html: JSON.stringify(schema)
        }}
        type={'application/ld+json'}
      />
    </Head>
  );
};

/**
 * Export `SchemaFaq` component.
 */

export default SchemaFaq; 